export const ROOT_NAME_SPACE = 'LiveLine';

export const aip = 'liveline';
